module.exports = __webpack_public_path__ + "img/mcps-logo.dcd19baa.jpg";